import React, { FC } from 'react';
import { Content } from '../../components/content';
import { Header } from '../../components/header/header';
import { Page } from '../../components/page';
import { ProductAvailabilityBody } from './body';
import { GetProductAvailabilityAtPlantQuery } from './queries/get-product-availability-at-plant';
import { PRODUCT_AVAILABILITY_PAGE_ROUTE } from './route';

const ProductAvailabilityPage: FC<{
  productId: string;
  shipToId: string;
  plantId: string;
}> = ({ productId, shipToId, plantId }) => {
  return (
    <Page
      data-type="page"
      data-page={PRODUCT_AVAILABILITY_PAGE_ROUTE}
      data-ship-to-id={shipToId}
      data-product-id={productId}
      data-plant-id={plantId}
    >
      <Header />

      <Content>
        <GetProductAvailabilityAtPlantQuery
          productId={productId}
          shipToId={shipToId}
          plantId={plantId}
          render={productAvailabilityAtPlant => {
            return (
              <ProductAvailabilityBody
                shipToId={shipToId}
                productAvailability={productAvailabilityAtPlant}
              />
            );
          }}
        />
      </Content>
    </Page>
  );
};

export { ProductAvailabilityPage };
